import React, { FC, ReactNode } from 'react';

import {
  Stepper as MuiStepper,
  Step,
  StepButton,
  StepConnector,
  StepLabel,
  Typography,
} from '@mui/material';
import { useTheme } from '@mui/system';
import { useRouter } from 'next/router';
import { FUNNEL_PATH_NAMES } from 'src/utils/constants';

import CheckCircleIcon from '../Icons/ModifiedMUIIcons/CheckCircle';

type Props = {
  activeStep: number;
  stepLabels: ReactNode[];
};

const Stepper: FC<Props> = ({ activeStep, stepLabels }) => {
  const router = useRouter();
  const theme = useTheme();

  const navigateToStep = (idx: number) => () => {
    router.push(FUNNEL_PATH_NAMES[idx]);
  };

  /**
   * Have to wrap the component as such to pass in the color props
   */
  const CompletedIcon: React.FC = () => (
    <CheckCircleIcon
      color={theme.palette.primary.main}
      backgroundColor={theme.palette.primary.contrastText}
    />
  );

  return (
    <MuiStepper
      alternativeLabel
      activeStep={activeStep}
      sx={{ overflow: 'hidden' }}
      connector={
        <StepConnector
          sx={{
            top: '50%',
            left: 'calc(-50% + 2.25rem)',
            right: 'calc(50% + 2.25rem)',
          }}
        />
      }
    >
      {stepLabels.map((s, idx) => (
        <Step key={`step-${idx}`}>
          <StepButton
            onClick={navigateToStep(idx)}
            disabled={idx >= activeStep}
          >
            <StepLabel
              StepIconProps={{
                sx: {
                  '& .MuiStepIcon-text': {
                    typography: 'caption',
                  },
                },
              }}
              StepIconComponent={idx < activeStep ? CompletedIcon : undefined}
            >
              <Typography variant={'subtitle2'}>{s}</Typography>
            </StepLabel>
          </StepButton>
        </Step>
      ))}
    </MuiStepper>
  );
};

export default Stepper;
